import service from '.';

//login api
export const apiLogin = (info) => service.post('admin/loginAdmin', info, { request: 'raw' });
